"use client";

import { Vacancy } from "@entities/vacancy";
import { Collection } from "@shared/types";
import { VacancyListGridConfig } from "../../types";
import { DefaultMicroVacancyListGrid } from "./default-micro-vacancy-list-grid";

export function MicroVacancyListGrid({
  initialData,
  config,
  path = "/lowongan-dalam-negeri/lowongan-mikro",
}: {
  initialData: Collection<Vacancy> | null;
  searchParams: any;
  config: VacancyListGridConfig;
  path?: string;
}) {
  if (!initialData) {
    return <></>;
  }

  return <DefaultMicroVacancyListGrid collection={initialData} config={config} path={path} />;
}
